export default __webpack_public_path__ + "static/media/facebook-light-old.39f8fe7f.svg";